// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import toast from 'react-hot-toast'

// ** Axios Imports
import axios from 'axios'

export const getRecieveData = createAsyncThunk('appMarsoulat/getRecieveData', async () => {
  const response = await axios.post('https://api.fntpf.ir/marsoolat/admin/getCurrentRecieve', null)
  if (response.data.status) return response.data.marsoolat
})
export const getRecieveDataFilter = createAsyncThunk('appMarsoulat/getRecieveDataFilter', async () => {
  const response = await axios.post('https://api.fntpf.ir/marsoolat/admin/getCurrentRecieve', null)
  if (response.data.status) return response.data
})
export const getArchData = createAsyncThunk('appMarsoulat/getArchData', async () => {
  const response = await axios.post('https://api.fntpf.ir/marsoolat/admin/getArchData', null)
  if (response.data.status) return response.data.marsoolat
})
export const getArchDataFilter = createAsyncThunk('appMarsoulat/getArchDataFilter', async () => {
  const response = await axios.post('https://api.fntpf.ir/marsoolat/admin/getArchData', null)
  if (response.data.status) return response.data
})
export const getSentData = createAsyncThunk('appMarsoulat/getSentData', async () => {
  const response = await axios.post('https://api.fntpf.ir/marsoolat/admin/getCurrentSent', null)
  if (response.data.status) return response.data.marsoolat
})
export const getSentDataFilter = createAsyncThunk('appMarsoulat/getSentDataFilter', async () => {
  const response = await axios.post('https://api.fntpf.ir/marsoolat/admin/getCurrentSent', null)
  if (response.data.status) return response.data
})
export const getSingle = createAsyncThunk('appMarsoulat/getSingle', async id => {
  const response = await axios.post('https://api.fntpf.ir/marsoolat/admin/getSingleMarsoule', { id })
  if (response.data.status) return response.data.marsooleh
})


export const getClientInfo = createAsyncThunk('appMarsoulat/getClientInfo', async (params) => {
  const response = await axios.post('https://api.fntpf.ir/get/ClientInfo', { id: params})
  if (response.data.status) return response.data.client
})


export const getAllClients = createAsyncThunk('appMarsoulat/getAllClients', async (params) => {
  const response = await axios.post('https://api.fntpf.ir/getclients', { account_type: params})
  return response.data
})

export const getTaskData = createAsyncThunk('appMarsoulat/getTaskData', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/gettask', params)
  return response.data.tasks
})

export const getTaskData2 = createAsyncThunk('appMarsoulat/getTaskData2', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/gettask', params)
  return response.data.tasks
})

export const getDataCount = createAsyncThunk('appMarsoulat/getDataCount', async (params) => {
  const response = await axios.post('https://api.fntpf.ir/admin/getallghateCount', { account_type: params})
  return response.data
})

export const addNews = createAsyncThunk('appMarsoulat/addNews', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/addnews', params)
  if (response.data.status) {
    toast.success(response.data.message)
    return response.data
  } else toast.error(response.data.message)
})

export const getData = createAsyncThunk('appMarsoulat/getData', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getallghate', params)
  console.log(response.data.count)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.count
  }
})

export const getPayment = createAsyncThunk('appMarsoulat/getPayment', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/user/payments', params)
  return response.data
})
export const getFilteredPayment = createAsyncThunk('appMarsoulat/getFilteredPayment', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/user/filteredpayments', params)
  return response.data
})

export const getClients = createAsyncThunk('appMarsoulat/getClients', async params => {
  const response = await axios.post('https://api.fntpf.ir/getclients', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.count
  }
})

export const getUser = createAsyncThunk('appMarsoulat/getUser', async id => {
  const response = await axios.post('https://api.fntpf.ir/admin/getUser', { id })
  return response.data.user
})

export const getAllAgents = createAsyncThunk('appMarsoulat/getAllAgents', async () => {
  console.log('testi')
  const response = await axios.post('https://api.fntpf.ir/admin/getagentsV3forGhate', { id:1 })
  if (response.data.status) return response.data.users
})
export const getRequest = createAsyncThunk('appMarsoulat/getRequest', async id => {
  const response = await axios.post('https://api.fntpf.ir/admin/getUser', { id })
  return response.data.user
})

export const editUser = createAsyncThunk('appMarsoulat/editUser', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/updateagentprofile', params)
  if (response.data.status) {
    toast.success(response.data.message)
    return response.data
  } else toast.error(response.data.message)
})

export const editClient = createAsyncThunk('appMarsoulat/editClient', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/updateclientprofile', params)
  if (response.data.status) {
    toast.success(response.data.message)
    return response.data
  } else toast.error(response.data.message)
})

export const getNews = createAsyncThunk('appMarsoulat/getNews', async params => {
  const response = await axios.post('https://api.fntpf.ir/admin/getAgentNews', params)
  return response.data.news
})

export const addUser = createAsyncThunk('appMarsoulat/addUser', async (user, { dispatch, getState }) => {
  console.log("USER Not ADDED!", user)
  const response = await axios.post('https://api.fntpf.ir/addagent', user)
  console.log("USER ADDED!", response)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  if (response.data.status) {
    toast.success(response.data.message)
  } else toast.error(response.data.error)
  return user
})

export const addClient = createAsyncThunk('appMarsoulat/addClient', async (user, { dispatch, getState }) => {
  console.log("USER Not ADDED!", user)
  const response = await axios.post('https://api.fntpf.ir/addclient', user)
  console.log("USER ADDED!", response)
  await dispatch(getClients(getState().users.params))
  await dispatch(getAllClients())
  if (response.data.status) {
    toast.success(response.data.message)
  } else toast.error(response.data.error)
  return user
})

export const deleteUser = createAsyncThunk('appMarsoulat/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const appMarsoulatSlice = createSlice({
  name: 'appMarsoulat',
  initialState: {
    tasks: [],
    subsetTasks: [],
    dataCount:{},
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    editStatus: {},
    addNewsStatus: null,
    newsHistory: null,
    payments: [],
    allPayments: [],
    allAgents: [],
    recieveData: [],
    recieveDataFilter: [],
    sentData: [],
    sentDataFilter: [],
    archData: [],
    archDataFilter: [],
    marsouleh: {}
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getRecieveData.fulfilled, (state, action) => {
        state.recieveData = action.payload
      })
      .addCase(getRecieveDataFilter.fulfilled, (state, action) => {
        state.recieveDataFilter = action.payload
      })
      .addCase(getArchData.fulfilled, (state, action) => {
        state.archData = action.payload
      })
      .addCase(getArchDataFilter.fulfilled, (state, action) => {
        state.archDataFilter = action.payload
      })
      .addCase(getSentData.fulfilled, (state, action) => {
        state.sentData = action.payload
      })
      .addCase(getSentDataFilter.fulfilled, (state, action) => {
        state.sentDataFilter = action.payload
      })
      .addCase(getSingle.fulfilled, (state, action) => {
        state.marsouleh = action.payload
      })
      .addCase(getAllClients.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getTaskData.fulfilled, (state, action) => {
        state.tasks = action.payload
      })
      .addCase(getTaskData2.fulfilled, (state, action) => {
        state.subsetTasks = action.payload
      })
      .addCase(getDataCount.fulfilled, (state, action) => {
        state.dataCount = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      }).addCase(getClients.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.editStatus = action.payload
      }).addCase(editClient.fulfilled, (state, action) => {
          state.editStatus = action.payload
      }).addCase(getNews.fulfilled, (state, action) => {
        state.newsHistory = action.payload
      }).addCase(addNews.fulfilled, (state, action) => {
        state.addNewsStatus = action.payload
      }).addCase(getPayment.fulfilled, (state, action) => {
        state.payments = action.payload.data
        state.allPayments = action.payload.allData
      }).addCase(getFilteredPayment.fulfilled, (state, action) => {
        state.payments = action.payload.data
        state.allPayments = action.payload.allData
      }).addCase(getClientInfo.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      }).addCase(getAllAgents.fulfilled, (state, action) => {
        state.allAgents = action.payload
      })
  }
})

export default appMarsoulatSlice.reducer
